import type { ReactNode } from 'react';
import MainMenu from '../MainMenu/MainMenu';
import ToastContainer from '../ToastContainer/ToastContainer';
import ErrorModalContainer from '../ErrorModalContainer/ErrorModalContainer';
import { useRetrieveUser } from '../../hooks/useRetrieveUser';

type PublicCatalogLayoutProps = {
  children: ReactNode;
};

const PublicCatalogLayout = ({ children }: PublicCatalogLayoutProps) => {
  useRetrieveUser();

  return (
    <div className="eateliers-brand lookbook-shell text-foreground">
      <MainMenu />
      {children}
      <ToastContainer />
      <ErrorModalContainer />
    </div>
  );
};

export default PublicCatalogLayout;
